import { cx } from '@emotion/css';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import dayjs from 'dayjs';
import { PaymentStatusChip } from '@/features/payment-status-chip';
import { useGetPaymentsPartnerQuery } from '@/models/payments';
import { useTranslation } from 'react-i18next';
import { VAT_FALLBACK } from '@/features/summary';

export const PartnerPayments = () => {
  const { data } = useGetPaymentsPartnerQuery({ page: 1, size: 100 });
  const { t } = useTranslation();
  const sortedData = data
    ? [...data].sort((a, b) =>
        dayjs(a.paymentMonth).isAfter(dayjs(b.paymentMonth)) ? -1 : 1
      )
    : [];

  return (
    <div className="w-full mt-5 flex-1">
      <div className=" mt-7 mb-5">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{t('taxi_partner.payments.id')}</TableCell>
                <TableCell>{t('taxi_partner.payments.payment_for')}</TableCell>
                <TableCell>{t('taxi_partner.payments.earned')}</TableCell>
                <TableCell>{t('taxi_partner.payments.bonus')}</TableCell>
                <TableCell>{t('taxi_partner.payments.total_net')}</TableCell>
                <TableCell>{t('taxi_partner.payments.total_gross')}</TableCell>
                <TableCell>{t('taxi_partner.payments.created_at')}</TableCell>
                <TableCell>{t('taxi_partner.payments.paid_at')}</TableCell>
                <TableCell>{t('taxi_partner.payments.status.label')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedData.map((row) => {
                const totalNet = Number(row.amount) + Number(row.bonus) || 0;
                const totalGross =
                  totalNet > 0 ? totalNet + totalNet * VAT_FALLBACK : 0;
                const earned = parseFloat(row.amount).toFixed(2);
                const bonus = row.bonus
                  ? parseFloat(row.bonus).toFixed(2)
                  : '0.00';

                return (
                  <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell>{row.invoiceId}</TableCell>
                    <TableCell>
                      {dayjs(row.paymentMonth).format('MM/YYYY')}
                    </TableCell>
                    <TableCell>{earned}</TableCell>
                    <TableCell>
                      <span
                        className={cx({
                          'text-green-600':
                            !!row.bonus && parseFloat(row.bonus) > 0,
                          'text-gray-400':
                            !row.bonus || parseFloat(row.bonus) === 0,
                        })}
                      >
                        {!!row.bonus && parseFloat(row.bonus) > 0 ? (
                          <span className="mr-1">+</span>
                        ) : (
                          <span className="mr-3" />
                        )}
                        {bonus}
                      </span>
                    </TableCell>
                    <TableCell>{totalNet.toFixed(2)}</TableCell>
                    <TableCell>{totalGross.toFixed(2)}</TableCell>
                    <TableCell>
                      {dayjs(row.createdAt).format('DD/MM/YYYY')}
                    </TableCell>
                    <TableCell>
                      {row.paidAt
                        ? dayjs(row.paidAt).format('DD/MM/YYYY')
                        : '-'}
                    </TableCell>
                    <TableCell>
                      <PaymentStatusChip status={row.status} />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};
